import { Text } from '@farmersdog/corgi-x';

export interface DescriptionProps {
  children: string;
}

export function Description({ children }: DescriptionProps) {
  return (
    <Text variant="article-20" as="p">
      {children}
    </Text>
  );
}
